import React from "react";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="border-t border-[#F5F2EB]/10 mt-32">
      <div className="mx-auto max-w-7xl px-6 md:px-12 py-12 flex flex-col md:flex-row gap-8 justify-between">
        <div>
          <div className="flex items-center gap-3 mb-4">
            <span className="w-2 h-2 bg-[#D95B38] inline-block" />
            <span className="font-serif italic text-2xl">AgentReply</span>
          </div>
          <p className="font-mono text-sm text-[#A39A8F] max-w-sm">
            Build AI agents that reply on WhatsApp, your website, anywhere. Personality, knowledge, voice — all yours.
          </p>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-3 gap-12 font-mono text-xs uppercase tracking-[0.2em]">
          <div>
            <div className="text-[#A39A8F] mb-3">Product</div>
            <ul className="space-y-2 text-[#F5F2EB]">
              <li><a href="/#features" className="hover:text-[#D95B38]" data-testid="footer-features">Features</a></li>
              <li><a href="/#pricing" className="hover:text-[#D95B38]" data-testid="footer-pricing">Pricing</a></li>
              <li><a href="/#faq" className="hover:text-[#D95B38]" data-testid="footer-faq">FAQ</a></li>
              <li><a href="/blog" className="hover:text-[#D95B38]" data-testid="footer-blog">Blog</a></li>
              <li><a href="/leaderboard" className="hover:text-[#D95B38]" data-testid="footer-leaderboard">Affiliate leaderboard</a></li>
              <li><a href="/help" className="hover:text-[#D95B38]" data-testid="footer-help">Help center</a></li>
            </ul>
          </div>
          <div>
            <div className="text-[#A39A8F] mb-3">Legal</div>
            <ul className="space-y-2 text-[#F5F2EB]">
              <li><a href="/legal/privacy" className="hover:text-[#D95B38]" data-testid="footer-privacy">Privacy</a></li>
              <li><a href="/legal/terms" className="hover:text-[#D95B38]" data-testid="footer-terms">Terms</a></li>
              <li><a href="/legal/cookies" className="hover:text-[#D95B38]" data-testid="footer-cookies">Cookies</a></li>
              <li><a href="/legal/gdpr" className="hover:text-[#D95B38]" data-testid="footer-gdpr">GDPR</a></li>
            </ul>
          </div>
          <div>
            <div className="text-[#A39A8F] mb-3">Company</div>
            <ul className="space-y-2 text-[#F5F2EB]">
              <li><a href="/about" className="hover:text-[#D95B38]" data-testid="footer-about">About</a></li>
              <li><a href="/contact" className="hover:text-[#D95B38]" data-testid="footer-contact-page">Contact</a></li>
              <li><a href="/services" className="hover:text-[#D95B38]" data-testid="footer-services">For agencies</a></li>
              <li><a href="/help/billing" className="hover:text-[#D95B38]" data-testid="footer-billing">Billing</a></li>
            </ul>
          </div>
        </div>
      </div>
      <div className="border-t border-[#F5F2EB]/10 py-6">
        <div className="mx-auto max-w-7xl px-6 md:px-12 flex flex-col md:flex-row justify-between items-start md:items-center gap-4 font-mono text-xs text-[#A39A8F]">
          <span>© 2026 AgentReply Labs</span>
          <div className="flex items-center gap-4 flex-wrap">
            <a
              href="https://trafficforge.ai"
              target="_blank"
              rel="dofollow noopener"
              data-testid="footer-trafficforge-badge"
              style={{
                display: "inline-flex",
                alignItems: "center",
                gap: "6px",
                padding: "6px 12px",
                background: "#1C1917",
                color: "#fff",
                borderRadius: "6px",
                textDecoration: "none",
                fontFamily: "system-ui, sans-serif",
                fontSize: "12px",
                fontWeight: 600,
              }}
            >
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#EA580C" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2" />
              </svg>
              Powered by TrafficForge AI
            </a>
            <span className="uppercase tracking-[0.3em]">Made for builders</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
